module.exports = __webpack_public_path__ + "static/media/icon-instructions-light.dcf5e07b.svg";